import axios from "axios";
import { setHeaders, interceptError } from "./axiosInterceptors";

// Axios instance
const axiosInstance = axios.create({
  baseURL: "/api",
  headers: {
    Accept: "application/json,text/plain",
  },
});

axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => interceptError(error),
);
setHeaders(axiosInstance);

export default axiosInstance;

export const axiosAssetsInstance = axios.create();
axiosAssetsInstance.interceptors.response.use(
  (response) => response.data,
  (error) => interceptError(error),
);
setHeaders(axiosAssetsInstance);

export const getCsrfToken = () => {
  const token = document.querySelector('meta[name="csrf-token"]');
  return token && token.getAttribute("content");
};
